import React from 'react';
import { Typography, Stack, Divider } from '@mui/material';
import { useTranslation } from 'react-i18next';

import useStats from './hooks/useStats';

import { useStyles } from './styles';

const GamecastStats = () => {
  const { stats } = useStats();
  const { t: translate } = useTranslation();

  const classes = useStyles();

  if (!stats) {
    return null;
  }

  return (
    <Stack sx={classes.root}>
      {[
        {
          title: translate('gamecastStats.videoResolution'),
          value: `${stats.frameWidth}x${stats.frameHeight}`,
        },
        {
          title: translate('gamecastStats.received'),
          value: stats.packetsReceived,
        },
        {
          title: translate('gamecastStats.framesDecoded'),
          value: stats.framesDecoded,
        },
        {
          title: translate('gamecastStats.packetsLost'),
          value: stats.packetsLost,
        },
        {
          title: translate('gamecastStats.bitrate'),
          value: Math.round(stats.totalDecodeTime),
        },
        {
          title: translate('gamecastStats.framerate'),
          value: stats.framesPerSecond,
        },
        {
          title: translate('gamecastStats.framesDropped'),
          value: stats.framesDropped,
        },
        {
          title: translate('gamecastStats.netRtt'),
          value: Math.round(stats.totalProcessingDelay),
        },
        {
          title: translate('gamecastStats.transferSpeed'),
          value: stats.transferSpeed,
        },
        {
          title: translate('gamecastStats.connectionSpeed'),
          value: stats.connectionSpeed,
        },
      ].map(({ title, value }, index) => (
        <Stack sx={classes.row} key={`${title}:${index}`}>
          <Typography sx={classes.text}>{title}</Typography>
          <Divider sx={classes.divider} />
          <Typography sx={classes.text}>{value}</Typography>
        </Stack>
      ))}
    </Stack>
  );
};

export default GamecastStats;
